<template>
  <div v-cloak>
    <div class="vx-card mb-4">
      <div class="vx-card__collapsible-content vs-con-loading__container">
        <div class="vx-card__body card-body">
          <div class="flex">
            <div class="w-full">
              <vs-button
                @click="showFilters = !showFilters"
                class="bg_purple float-right"
              >
                <div class="px-3">
                  <feather-icon
                    icon="FilterIcon"
                    svgClasses="h-4 w-4"
                    class="ico"
                  />
                  {{ $t("Filter") }}
                </div>
              </vs-button>
            </div>
          </div>
          <div class="vx-row" v-if="showFilters">
            <div class="vx-col w-full">
              <form>
                <div
                  class="grid lg:grid-cols-4 sm:grid-cols-2 grid-cols-1 items-end gap-4"
                >
                  <div>
                    <label class="vs-input--label">{{ $t("PartyType") }}</label>
                    <div class="w-full">
                      <v-select
                        label="name"
                        :options="partyTypes"
                        v-model="gridSearchData.PartyType"
                        :reduce="(x) => x.value"
                        dir="rtl"
                      >
                      </v-select>
                    </div>
                  </div>
                  <div>
                    <label class="vs-input--label">{{
                      $t("ContractName")
                    }}</label>
                    <div class="w-full">
                      <v-select
                        label="title"
                        :options="allContracts"
                        v-model="gridSearchData.ContractId"
                        :reduce="(x) => x.id"
                        dir="rtl"
                      >
                      </v-select>
                    </div>
                  </div>
                  <div>
                    <div class="w-full">
                      <vs-input
                        class="inputx"
                        v-model="gridSearchData.MinAmount"
                        :label="$t('MinPrice')"
                      />
                    </div>
                  </div>
                  <div>
                    <div class="w-full">
                      <vs-input
                        class="inputx"
                        v-model="gridSearchData.MaxAmount"
                        :label="$t('MaxPrice')"
                      />
                    </div>
                  </div>
                  <div>
                    <div class="w-full">
                      <vs-input
                        class="inputx"
                        v-model="gridSearchData.PartyName"
                        :label="$t('PartyName')"
                      />
                    </div>
                  </div>
                  <div>
                    <label class="vs-select--label datepicker-lb">{{
                      $t("FromDate")
                    }}</label>
                    <date-picker
                      v-model="gridSearchData.MinCreateTime"
                      type="datetime"
                      format="jYYYY-jMM-jDD HH:mm:ss"
                      display-format="jYYYY-jMM-jDD HH:mm:ss"
                      class="date-picker"
                      :label="$t('FromDate')"
                      :clearable="true"
                    />
                  </div>
                  <div>
                    <label class="vs-select--label datepicker-lb">{{
                      $t("ToDate")
                    }}</label>
                    <date-picker
                      v-model="gridSearchData.MaxCreateTime"
                      type="datetime"
                      format="jYYYY-jMM-jDD HH:mm:ss"
                      display-format="jYYYY-jMM-jDD HH:mm:ss"
                      class="date-picker"
                      :label="$t('ToDate')"
                      :clearable="true"
                    />
                  </div>
                  <div
                    class="2xl:col-span-1 lg:col-span-4 sm:col-span-1 flex-grow flex flex-nowrap gap-4 mt-6 justify-end items-end"
                    style="min-width: max-content"
                  >
                    <vs-button
                      type="filled"
                      class="flex-shrink-0"
                      color="#3ec9d6"
                      @click.prevent="resetForm"
                      >{{ $t("ResetFilter") }}</vs-button
                    >
                    <vs-button
                      type="filled"
                      class="flex-shrink-0"
                      @click.prevent="submitFilter()"
                      v-has-permission="permission21"
                      >{{ $t("SubmitFilter") }}</vs-button
                    >
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="vx-row pt-4">
            <div class="vx-col w-full mb-base">
              <data-grid
                ref="grid"
                stripe
                :data-source="gridDataSource"
                :search-data="gridSearchData"
                :columns="[
                  { title: $t('PartyName'), sort: 'PartyName' },
                  { title: $t('SalePersonName') },
                  { title: $t('SiteOrderNumber'), sort: 'SiteOrderNumber' },
                  { title: $t('DraftOrderId'), sort: 'DraftOrderId' },
                  { title: $t('OrderId'), sort: 'OrderId' },
                  { title: $t('TadbirId'), sort: 'TadbirId' },
                  {
                    title: $t('PartyType'),
                    sort: 'PartyType',
                  },
                  { title: $t('ContractName'), sort: 'ContractName' },
                  {
                    title: $t('TotalAmountForPayment'),
                    name: 'TotalAmountForPayment',
                  },
                  { title: $t('CreateOn'), sort: 'CreateOn' },
                  { title: $t('Action') },
                ]"
              >
                <template slot-scope="{ row }">
                  <td style="width: 13%">
                    {{ row.orderPartyInfoQueryDto.name }}
                  </td>
                  <td style="width: 8%">
                    {{
                      row.orderSalePersonInfo
                        ? row.orderSalePersonInfo.name
                        : "----"
                    }}
                  </td>
                  <td style="width: 7%">
                    {{ "APO-" + row.basketId }}
                  </td>
                  <td style="width: 7%">
                    {{ row.draftOrderId }}
                  </td>
                  <td style="width: 5%">
                    {{ row.id }}
                  </td>
                  <td style="width: 5%">
                    {{ row.tadbirId }}
                  </td>
                  <td style="width: 10%">
                    {{ row.orderPartyInfoQueryDto.partyType }}
                  </td>
                  <td style="width: 17%">
                    <span v-if="row.orderContractQuery.contractId">
                      {{ row.orderContractQuery.contractTitle }}
                    </span>
                    <span v-else>-</span>
                  </td>
                  <td style="width: 15%">
                    {{ Number(row.totalAmountForPayment).toLocaleString() }}
                    ریال
                  </td>

                  <td style="width: 10%">
                    {{ row.createOn.split(" ")[0] }}<br />{{
                      row.createOn.split(" ")[1]
                    }}
                  </td>
                  <td style="width: 10%">
                    <router-link :to="{ path: '/Order/Details/' + row.id }">
                      <vs-button
                        radius
                        color="success"
                        size="small"
                        type="gradient"
                        icon-pack="feather"
                        icon="icon-eye"
                        class="mx-4 d-inline"
                        v-has-permission="permission20"
                      ></vs-button>
                    </router-link>
                  </td>
                </template>
              </data-grid>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>
<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import vSelect from "vue-select";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "saleManagement_Orders_Index",
  computed: {
    ...mapGetters({
      allContracts: "sale/list",
    }),
  },
  data() {
    return {
      permission21: "GetAllDraftOrder",
      permission20: "GetSaleAgentBasketById|GetAllDraftOrderById",
      showFilters: false,
      gridDataSource: {
        type: "app",
        service: "Sales/api/OrdersQuery",
      },
      gridSearchData: {
        keyword: "",
      },
      partyTypes: [
        { name: "حقیقی", value: "Individual" },
        { name: "حقوقی", value: "Legal" },
      ],
    };
  },
  mounted() {
    this.fetchContract();
  },
  methods: {
    ...mapActions({
      fetchContract: "sale/fetchNoSkip",
    }),
    submitFilter() {
      this.$refs.grid.renderGrid(1, true);
    },
    resetForm() {
      this.gridSearchData = {
        PartyName: "",
        PartyType: "",
        ContractId: "",
        MinAmount: "",
        MaxAmount: "",
        MinCreateTime: "",
        MaxCreateTime: "",
      };
      setTimeout(() => {
        this.$refs.grid.renderGrid(1, true);
      }, 0);
    },
  },
  components: {
    DataGrid,
    "v-select": vSelect,
    datePicker: VuePersianDatetimePicker,
  },
};
</script>
